import React from 'react';
import { FlashOn } from "@material-ui/icons";
import TemplateSelect from "./TemplateSelect";
import { SCOPE_PLACEHOLDER } from "./constants";
import { TextArea } from "src/shared-components/Form";

const ScopeBuilder = () => {
  return (
    <div className="flex flex-col w-full">
      <h3 className="text-2xl font-medium">What do you need done in the next 30-90 days?</h3>
      <div className="flex items-center mb-5">
        <p>Start with a</p>
        <FlashOn className="text-orange-300 ml-0.5 -mr-0.5" style={{ height: '1rem', width: '1rem' }} />
        <p className="text-orange-300">Template</p>
        <p>. Or, write your own.</p>
      </div>
      <div className="flex flex-col items-start space-y-2">
        <TemplateSelect />
        <div className="w-full">
          <TextArea
            id="scopeText"
            name="text"
            autoComplete="off"
            placeholder={SCOPE_PLACEHOLDER}
            required
            height="h-40"
          />
        </div>
      </div>
    </div>
  )
}

export default ScopeBuilder;
